import React from "react";

export const ServiceContext = React.createContext({
  eventBusService: null,
});

export const ServicesProvider = React.memo(({ children, context }) => {
  return (
    <ServiceContext.Provider value={context}>
      {children}
    </ServiceContext.Provider>
  );
});
